import { Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEO, { createOrganizationSchema, createWebPageSchema, createLocalBusinessSchema, createWebSiteSchema } from '../../components/feature/SEO';
import Hero from './components/Hero';
import WhatsAppButton from '../../components/base/WhatsAppButton';


// Lazy-load below-fold sections to reduce initial bundle & render-blocking
const Stats = lazy(() => import('./components/Stats'));
const WhyChooseUs = lazy(() => import('./components/WhyChooseUs'));
const WhyChooseUniqueCode = lazy(() => import('./components/WhyChooseUniqueCode'));
const CoreServices = lazy(() => import('./components/CoreServices'));
const CTA = lazy(() => import('./components/CTA'));

// Minimal skeleton shown while lazy sections load
const SectionSkeleton = () => (
  <div className="py-24 bg-white animate-pulse">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="h-6 bg-gray-100 rounded w-32 mx-auto mb-4"></div>
      <div className="h-10 bg-gray-100 rounded w-64 mx-auto mb-12"></div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[1, 2, 3].map((i) => (
          <div key={i} className="h-48 bg-gray-100 rounded-2xl"></div>
        ))}
      </div>
    </div>
  </div>
);

const Home = () => {
  const { t } = useTranslation();
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://unqcode.com';

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title={t('seo.homeTitle')}
        description={t('seo.homeDesc')}
        keywords="Unique Code, الكود المميز, web development, mobile apps, AI solutions, digital marketing, branding, Saudi Arabia, Riyadh, تطوير مواقع, تطبيقات الجوال, حلول الذكاء الاصطناعي, تسويق رقمي"
        canonical={`${siteUrl}/`}
        ogType="website"
        schema={{
          '@context': 'https://schema.org',
          '@graph': [
            createWebSiteSchema(),
            createOrganizationSchema(),
            createLocalBusinessSchema(),
            createWebPageSchema(
              t('seo.homeTitle'),
              'Leading digital solutions agency in Saudi Arabia. Web development, mobile apps, AI solutions, branding, and digital marketing services.',
              '/'
            ),
          ],
        }}
      />
      <Navbar />
      <main className="flex-grow">
        {/* Hero is critical — loaded eagerly */}
        <Hero />

        {/* Below-fold sections — lazy loaded */}
        <Suspense fallback={<SectionSkeleton />}>
          <Stats />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <WhyChooseUs />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <WhyChooseUniqueCode />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <CoreServices />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <CTA />
        </Suspense>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Home;
